const base = [
  'inline-flex items-center justify-center font-semibold rounded-lg transition-colors',
  'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-600',
  'disabled:opacity-50 disabled:pointer-events-none',
].join(' ')

const sizes = {
  md: 'h-11 px-5 text-base',
  lg: 'h-12 px-6 text-base md:h-14 md:text-lg',
}

const variants = {
  primary:   'bg-brand-600 text-white hover:bg-brand-700 active:bg-brand-700',
  secondary: 'bg-white text-ink-900 border border-ink-300 hover:bg-ink-100',
  ghost:     'text-ink-700 hover:bg-ink-100',
}

export function Button({
  as: As = 'button',
  variant = 'primary',
  size = 'md',
  className = '',
  ...props
}) {
  return (
    <As
      className={`${base} ${sizes[size]} ${variants[variant]} ${className}`}
      {...props}
    />
  )
}
